import { collectionsDuck } from '@eb/redux-destination';

const { api: collectionsApi } = collectionsDuck;

export const getUserCollections = async (id: string) => {
    const collections = await collectionsApi.getUserCollections(id);
    return collections;
};
